import { useQuery } from "@tanstack/react-query";
import { List } from "semantic-ui-react";
import { extractCustom, isUrl } from "./helpers";
import TableCustomFieldModal from "./TableCustomFieldModal";

import CustomFieldService from "services/CustomField";

export const useCustomFields = (modelType, enabled = true) => {
  const { data } = useQuery({
    queryKey: ["customFieldConfigs", modelType],
    queryFn: () => CustomFieldService.getCustomFieldConfigsForModel(modelType),
    enabled: !!modelType && enabled,
  });

  return data ?? [];
};

export const renderCustomFieldValue = (field, customFields) => {
  const config = customFields.find(cf => cf.label === field.key);
  if (isUrl(field.value)) {
    return (
      <a href={field.value} target="_blank" rel="noopener noreferrer">
        {field.value}
      </a>
    );
  } else if (Array.isArray(field.value)) {
    return field.value.join(", ");
  } else if (config?.field_type === "table") {
    return (
      <TableCustomFieldModal
        fieldName={field.key}
        fieldValue={field.value}
        trigger={
          <span
            style={{
              cursor: "pointer",
            }}
          >
            {field.value}
          </span>
        }
      />
    );
  } else {
    return field.value;
  }
};

const CustomItems = ({
  items,
  modelType,
  useHeaders = false,
  noEmptyLabel = false,
}) => {
  let custom = extractCustom(items);
  const customFields = useCustomFields(modelType);

  if (custom.length === 0) {
    return noEmptyLabel ? null : "None";
  }

  return custom.map((field, index) => (
    <List.Item key={index} style={{ wordWrap: "break-word" }}>
      {useHeaders ? <List.Header>{field.key}:</List.Header> : `${field.key}:`}
      {renderCustomFieldValue(field, customFields)}
    </List.Item>
  ));
};

export default CustomItems;
